import _ from 'lodash';
import React, { Component } from 'react';
import { Doughnut } from 'react-chartjs-2';

const Chart = ({ data }) => <Doughnut data={data} />;
// grupos:
//
// Audio,
// Celulares,
// Climatización,
// Computación,
// Cuidado personal,
// Electrodomésticos,
// Iluminación,
// TV Video,
// Videojuegos

const getLabelColor = label => {
  switch (label) {
    case 'Audio': // orange kind of
      return '#FF6F59';
    case 'Celulares': // dark purple
      return '#420039';
    case 'Climatización': // yellowish (pastel)
      return '#F5DD90';
    case 'Computación': // sp-green
      return '#7fb800';
    case 'Cuidado personal': // sp-orange
      return '#f6511d';
    case 'Electrodomésticos': // sp-blue
      return '#0d2c54';
    case 'Iluminación': // sp-yellow
      return '#ffb400';
    case 'TV Video': // indigo
      return '#586BA4';
    case 'Videojuegos': // sp-light-blue
      return '#00a6ed';
    default:
      // pastel
      return '#FCFCFC';
  }
};

class ConsumoTotal extends Component {
  static getDerivedStateFromProps(props) {
    const { selected = [] } = props;
    if (!selected || selected.length === 0) {
      return { labels: [], datasets: [{}] };
    }
    const selectedOptions = selected.map(item => {
      if (!item.selectedOption) {
        return item;
      }
      const itemWithOptions = {
        ...item.selectedOption,
        cantidad: item.cantidad,
        horas: item.horas
      };
      return itemWithOptions;
    });
    const groupLabels = _.uniqBy(selectedOptions, 'grupo').map(item => item.grupo);
    const sortedLabels = _.sortBy(groupLabels);
    const groups = _.groupBy(selectedOptions, 'grupo');
    const consumoByLabel = label => {
      const groupedItems = groups[label];
      const consumo = groupedItems.map(
        item => Number(item.potencia) * Number(item.cantidad) * Number(item.horas)
      );
      return consumo;
    };
    const FinalConsumeByGroup = label => {
      const consumos = consumoByLabel(label);
      return consumos.reduce((acc, current) => acc + current, 0);
    };
    return {
      labels: sortedLabels.map(label => label || 'Sin Grupo'),
      datasets: [
        {
          data: sortedLabels.map(label => FinalConsumeByGroup(label)),
          backgroundColor: sortedLabels.map(label => getLabelColor(label))
        }
      ]
    };
  }
  state = {};
  render() {
    const { selected = [] } = this.props;
    if (!selected || selected.length === 0) {
      return (
        <div style={{ textAlign: 'center' }}>
          <h6>Consumo Total</h6>
          <h2 className="h1">0 Wh</h2>
          <br />
          <br />
          <div>
            <p className="lead">
              Una vez comiences a seleccionar artículos, podrás visualizar tu consumo!
            </p>
          </div>
        </div>
      );
    }

    const selectedOptions = selected.map(item => {
      if (!item.selectedOption) {
        return item;
      }
      const itemWithOptions = {
        ...item.selectedOption,
        cantidad: item.cantidad,
        horas: item.horas
      };
      return itemWithOptions;
    });

    const consumoTotal = selectedOptions.map(
      item => Number(item.potencia) * Number(item.cantidad) * Number(item.horas)
    );
    // const groupLabels = _.uniqBy(selectedOptions, 'grupo').map(item => item.grupo);
    // const sortedLabels = _.sortBy(groupLabels);
    // const groups = _.groupBy(selectedOptions, 'grupo');
    // const groupedOptions = sortedLabels.map(label => ({
    //   label,
    //   options: groups[label]
    // }));

    return (
      <div style={{ textAlign: 'center' }}>
        <h6>Consumo Total</h6>
        <h2 className="h1">{consumoTotal.reduce((acc, current) => acc + current, 0)} Wh</h2>
        <Chart data={this.state} />
      </div>
    );
  }
}

export default ConsumoTotal;



// WEBPACK FOOTER //
// ./src/components/Home/CalculadoraConsumo/ConsumoTotal.js